export interface INodeVerification {
    name: string;
    type: string;
  }
  
  //List of node unknow by catalog
  export const ContentErrorNode = ({ node }: { node: INodeVerification[] }) => {
    return (
      <>
        <div>
          <h3>
            Brique(s) présente(s) dans le traitement importé mais pas dans
            l'application :
          </h3>
          <ul className="mt-3">
            {node.map((val) => (
              <li>
                Nom de la brique : {val.name}, Type de la brique : {val.type}
              </li>
            ))}
          </ul>
        </div>
      </>
    );
  };